/**
 * FileMessage
 *
 * Renders a file attachment with icon, name, size, and download button.
 */

import {
  DocumentIcon,
  DocumentTextIcon,
  TableCellsIcon,
  PresentationChartBarIcon,
  ArrowDownTrayIcon
} from '@heroicons/react/24/outline';
import MediaUploadService from '@/services/messaging/MediaUploadService';

const FILE_ICONS = {
  pdf: DocumentTextIcon,
  doc: DocumentTextIcon,
  spreadsheet: TableCellsIcon,
  presentation: PresentationChartBarIcon,
  file: DocumentIcon
};

export default function FileMessage({ media, isOwn }) {
  if (!media?.url) return null;

  const fileType = MediaUploadService.getFileType(media.mimeType);
  const Icon = FILE_ICONS[fileType] || DocumentIcon;
  const fileSize = MediaUploadService.formatFileSize(media.fileSize);

  return (
    <a
      href={media.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-3 p-3 rounded-lg border transition-colors ${
        isOwn
          ? 'border-primary-content/20 hover:bg-primary-content/10'
          : 'border-base-300 hover:bg-base-300/50'
      }`}
      style={{ minWidth: 200 }}
    >
      <div className={`p-2 rounded-lg ${isOwn ? 'bg-primary-content/20' : 'bg-base-300'}`}>
        <Icon className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{media.fileName || 'File'}</p>
        <p className="text-xs opacity-60">{fileSize}</p>
      </div>
      <ArrowDownTrayIcon className="w-4 h-4 opacity-60 flex-shrink-0" />
    </a>
  );
}
